import { Botao, Cores, Modal } from "@componentes-mu/componentes-mu";

import styles from "./styles.module.scss";
import { FlexColumn, FlexRow } from "../../../components/Flex";

export type ModalConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ModalConfirm = ({ isOpen, onClose, onConfirm }: ModalConfirmProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "none",
        boxShadow: "none",
      }}
    >
      <div className={styles.modalContent}>
        <FlexColumn gap="20px">
          <p className={styles.title}>
            Tem certeza que deseja solicitar feedback por{" "}
            <span className={styles.linkAccent}>Canal Direto</span>{" "}
            para esse ticket?
          </p>

          <p className={styles.subtitle}>
            Este recurso só pode ser utilizado em um ticket por vez.
          </p>

          <FlexRow gap="12px" justifyContent="center" className={styles.actions}>
            <Botao onClick={onClose} cor={Cores.CoresIdentidadeMU.azulMu}>
              Cancelar
            </Botao>

            <Botao onClick={onConfirm} cor={Cores.CoresIdentidadeMU.azulMu}>
              Confirmar
            </Botao>
          </FlexRow>
        </FlexColumn>
      </div>
    </Modal>
  );
};
